import { DefaultValue } from "recoil"
import { atom, selector } from "recoil"
import {
  AuctionParamsType,
  AuctionFinalResultProps,
  ActionAuctionFinalResult
} from "./types"

const AuctionStatus = window.MeetOnline.AuctionStatus
const AuctionIncrementType = window.MeetOnline.AuctionIncrementType

const defaultState = {
  title: "",
  description: "",
  currency: "GBP",
  incrementValue: "",
  interestIncrease: "",
  roomBid: "",
  ask: "",
  isModalBid: false,
  incrementType: AuctionIncrementType.MANUAL,
  isShowOverlay: true,
  action: "",
  status: AuctionStatus.NONE,
  bid: 0,
  historyBids: [],
  startingPrice: "",
  lastOnetoBid: ""
}

export const auctionParamsAtom = atom<AuctionParamsType>({
  key: "auctionParamsAtom",
  default: defaultState
})

export const auctionFinalResultAtom = atom<AuctionFinalResultProps>({
  key: "auctionFinalResultAtom",
  default: { isFinalModal: false }
})

export const auctionParamsSelector = selector<AuctionParamsType>({
  key: "auctionParamsSelector",
  get: ({ get }) => get(auctionParamsAtom),
  set: ({ get, set, reset }, newAuctionParam) => {
    if (newAuctionParam instanceof DefaultValue) return false

    const { action, bidTime, biddingUser, bid } =
      newAuctionParam as AuctionParamsType

    if (action === "reset") {
      reset(auctionParamsAtom)
    } else {
      const incrementType = get(auctionParamsAtom).incrementType
      let history = [...get(auctionParamsAtom).historyBids]
      // while reconnection - we get bid data which is already present in history
      // So don't push bid data in history is present
      if (bidTime !== undefined) {
        // create a local unique id for tracking uniqueness
        const bidLocalId = `${bid}_${new Date(bidTime).getTime()}` 
        const isPresent = history.some(item => item.id === bidLocalId)
        if(!isPresent)
          history.push({ id: bidLocalId, bid, bidTime, biddingUser })
      }

      let data = {}

      if (action === "bid" && incrementType === AuctionIncrementType.MANUAL) {
        data = { ...newAuctionParam, ask: 0 }
      } else {
        data = { ...newAuctionParam }
      }

      set(auctionParamsAtom, prevItem => ({
        ...prevItem,
        ...data,
        historyBids: history
      }))
    }
  }
})

export const auctionFinalResultSelector = selector({
  key: "auctionFinalResultSelector",
  get: ({ get }) => get(auctionFinalResultAtom),
  set: ({ get, set, reset }, newAuctionFinalResulParam) => {
    const { type, payload } =
      newAuctionFinalResulParam as ActionAuctionFinalResult
    if (type === "SHOW_MODAL") {
      const auctionParams = get(auctionParamsAtom)

      set(auctionFinalResultAtom, {
        ...get(auctionFinalResultAtom),
        ...{
          id: auctionParams.id,
          currency: auctionParams.currency,
          bid: auctionParams.bid,
          isFinalModal: true,
          idUser: auctionParams.biddingUser?.id
        }
      })
    }
    if (type === "RESET") {
      reset(auctionFinalResultAtom)
    }
    if (type === "UPDATE") {
      set(auctionFinalResultAtom, {
        ...get(auctionFinalResultAtom),
        ...payload
      })
    }
  }
})
